import EditIcon from "@/assets/icons/EditIcon";
import { Heading, Paragraph } from "@/components/ui/Typography";
import { useState } from "react";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import TitleAndDescriptionForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TitleAndDescriptionForm";
import { sanitizeHtml } from "@/utils/helpers/html";

const Overview = () => {
  const { templatePayload:data, updateTemplatePayload } = useMicroSiteContext();

      const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
  const [isEditing, setIsEditing] = useState(false);
  
    const handleSave = (formData:{title: string, description: string}) => {
      setIsEditing(false);
      const updatedPayload = {
        ...data,
        headerSectionTwo: {
          headerSectionTwoTitle: formData.title,
          headerSectionTwoDescription: formData.description
        },
      };
      updateTemplatePayload(updatedPayload);
    };

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full items-center text-center p-4 lg:p-20 gap-4 lg:gap-8 justify-center" style={{backgroundColor: data.branding.websiteColorCode}} >   
          <div className="flex items-center gap-3">
          <Heading level={1} style={{color: data.branding.textColorCode}}>{data.headerSectionTwo.headerSectionTwoTitle}</Heading>
{isEdit && <EditIcon fill="#fff" className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
          <Paragraph  style={{color: data.branding.textColorCode}} dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.headerSectionTwo.headerSectionTwoDescription ?? "") }} ></Paragraph>
      </div>
    )
  };

  return (
    <div>
      {isEditing ? <TitleAndDescriptionForm handleSave={handleSave} handleCancel={()=>setIsEditing(false)} data={{title: data.headerSectionTwo.headerSectionTwoTitle, description: data.headerSectionTwo.headerSectionTwoDescription}} /> : <PreviewComponent />}
    </div>
  )
}

export default Overview